module.exports = __webpack_public_path__ + "static/media/loginPattern.f97439aa.png";